import { BinderService } from '@/services/api/binder.service';
import { BinderLockService } from '@/services/app/binder-lock.service';
import { SignHistoryService } from '@/services/app/sign-history.service';
import { CommonModule, NgIf } from '@angular/common';
import { Component, effect } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';

interface parsedEvent {
  summary: string;
  details: string;
  severity: "success" | "secondary" | "info" | "danger" | "contrast" | "warn" | undefined;
  statusTag: string;
  date: string;
  timestamp: number;
  signer: string;
}

@Component({
    selector: 'app-events',
    imports: [SkeletonModule, TagModule, MenuModule, ButtonModule, RippleModule, CommonModule],
    template: `
    <div class="card border-round shadow-2 mb-2 p-4 text-left" *ngIf="!currentBinderService.isLoading()">
    <div class="flex justify-content-between align-items-center mb-2">
        <span class="text-2xl font-bold">Recent Activity</span>
        <div class="flex mr-0 ml-auto">
            <button pButton pRipple icon="pi pi-ellipsis-v" class="p-button-text p-button-plain p-button-rounded" (click)="menu3.toggle($event)"></button>
            <p-menu #menu3 [popup]="true" [model]="items"></p-menu>
        </div>
    </div>
    <ul class="list-none p-0 m-0">
        <li *ngFor="let event of events" class="flex flex-column md:flex-row md:align-items-center md:justify-content-between p-3 mb-3 surface-ground surface-border" style="border-radius: 10px;" [ngClass]="{
            'surface-border-warning': event.severity === 'warn',
            'surface-border-danger': event.severity === 'danger' || event.severity === 'contrast'
        }">
            <div>
                <div>
                    <span class="inline-flex justify-content-center align-items-center w-2rem h-2rem border-circle border-1 border-yellow-200">
                        <i class="pi pi-file text-yellow-700"></i>
                    </span>
                    <span class="text-yellow-700 font-bold ml-2">{{event.summary }}</span>
                </div>
                <p class="text-yellow-700 mt-2 mb-0"><span class="font-medium"><p-tag [severity]="event.severity" [value]="event.statusTag"/> {{event.date | date:'MM/dd/yyyy HH:mm a'}}</span></p>
            </div>
            
        </li>
    </ul>
</div>
    `
})
export class EventsComponent {
  showMore = false;

  validEvents = [ 
    1, 
    19,
    20,
    21,
    22,
    23,
    24,
    25
  ]
  items = [
    {label: 'Cancel Signature Request', icon: 'pi pi-times', command: () => this.confirmCancel()},
    {label: 'Send Reminder', icon: 'pi pi-bell', command: () => this.sendReminder()},
  ];
  binderId = 0


  constructor(public currentBinderService: BinderService, private signHistoryService: SignHistoryService, private confirmationService: ConfirmationService, private binderLockService: BinderLockService) {
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  get events() {
    return this.signHistoryService.events();
  }

  get lastSigner() {
    return this.signHistoryService.lastSigner();
  }

  sortEvents(events: parsedEvent[]) {
    if(events) {
      return events.sort((a, b) => {
        return b.timestamp - a.timestamp;
      });
    }
    return [];
  }

  sendReminder() {
      this.signHistoryService.sendReminder();
  }

  confirmCancel() {
    this.confirmationService.confirm({
        message: 'This will cancel the current signature request. Are you sure that you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon:"none",
        rejectIcon:"none",
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        rejectButtonStyleClass:"p-button-text",
        accept: () => {
          this.cancelSignatureRequest()   
        },
        reject: () => {
            // this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
    });
  }

  cancelSignatureRequest() {
    console.log('cancelSignatureRequest');
      this.binderLockService.handleSignUnlock(this.currentBinderService.currentBinder().BinderID);
  }
}
